/* eslint-disable react/jsx-key */
/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/no-distracting-elements */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useRef, useState } from "react";
import {
  BsArrowClockwise,
  BsBoxArrowUpRight,
  BsCaretDownFill,
  BsSearch,
} from "react-icons/bs";
import { CButton, CImage } from "@coreui/react";
import { MdStore } from "react-icons/md";
import { HiChevronDoubleRight } from "react-icons/hi";
import { RiDirectionLine } from "react-icons/ri";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { StoreContext } from "../context/StoreContext";
import Loader from "../global/Loader";
import CaptchaModal from "../components/CaptchaModal";

const StoreListing = (props) => {
  const options = [
    { value: "", label: "All Stores" },
    { value: "DESC", label: "Sort By Distance" },
    { value: "ASC", label: "Sort By Delivery Time" },
  ];
  const dropdownRef = useRef(null);
  const [vendorID, setVendorID] = useState("");
  const [visitStoreClicked, setVisitStoreClicked] = useState(false);
  const {
    nearbyStores,
    totalRecords,
    setPageNo,
    loader,
    selectedSortOption,
    setSelectedSortOption,
    selectedStore,
    dropdownOpen,
    setDropdownOpen,
    setStoresLatLng,
    selectedStoreID,
    setSelectedStoreID,
    scrollToMapSectionRef,
    setNearByStores,
    setRecenterCurLoc,
    searchText,
    setSearchText,
    fetchStores,
    setLoadmoreIsClicked,
  } = useContext(StoreContext);

  const getSelectedLabel = () => {
    const selected = options.find(
      (option) => option.value === selectedSortOption?.value,
    );
    return selected ? selected.label : "Select an option";
  };

  const navigateOnStore = (vendorId) => {
    setVisitStoreClicked(true);
    setVendorID(vendorId);
  };

  const handleRadioChange = (event, label) => {
    setSelectedSortOption({
      label,
      value: event.target.value,
    });
    setNearByStores([]);
    setPageNo(1);
    setDropdownOpen(false);
  };

  const handleStoreLatLng = (latt, lngg, storeID) => {
    setStoresLatLng({ lat: latt, lng: lngg });
    setSelectedStoreID(storeID);
  };

  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  };

  const openGoogleDirections = (toLat, toLng) => {
    const fromLat = localStorage.getItem("selectedCityLat");
    const fromLng = localStorage.getItem("selectedCityLng");
    const url = `https://www.google.com/maps/dir/?api=1&origin=${fromLat},${fromLng}&destination=${toLat},${toLng}&travelmode=driving`;
    window.open(url, "_blank");
  };

  const handleSearch = (e) => {
    const { value } = e.target;
    setSearchText(value);
    if (value.trim() === "") {
      setPageNo(1);
      if (selectedStore?.storeTypeID) {
        fetchStores("", selectedStore?.storeTypeID, 1);
      } else {
        fetchStores("", null, 1);
      }
    }
  };

  const handleSearchClick = () => {
    const trimmedValue = searchText.trim();
    if (trimmedValue !== "") {
      setPageNo(1);
      if (selectedStore?.storeTypeID) {
        fetchStores(trimmedValue, selectedStore?.storeTypeID, 1);
      } else {
        fetchStores(trimmedValue, null, 1);
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearchClick();
    } else if (e.key === "Backspace" && searchText.length === 1) {
      setSearchText("");
      if (selectedStore?.storeTypeID) {
        fetchStores("", selectedStore?.storeTypeID, 1);
      } else {
        fetchStores("", null, 1);
      }
    }
  };

  const handleLoadMore = () => {
    setPageNo((prev) => prev + 1);
    setLoadmoreIsClicked(true);
  };

  return (
    <div className="right-side-products default-page">
      <CaptchaModal
        visitStoreClicked={visitStoreClicked}
        setVisitStoreClicked={setVisitStoreClicked}
        vendorID={vendorID}
      />

      <span
        className={
          props?.sidebarShow
            ? "mobile-slide-icons active"
            : "mobile-slide-icons"
        }
        onClick={() => props?.setSidebarShow(true)}
        tabIndex={0}
        onKeyDown={(e) => e.preventDefault()}
        role="button"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 62 62"
          fill="none"
        >
          <circle cx="31" cy="31" r="31" fill="#058E72" fillOpacity="0.14" />
          <path
            d="M17.667 40.9995C17.447 41.0045 17.2282 40.9645 17.0242 40.882C16.8201 40.7995 16.6351 40.6761 16.4804 40.5196C16.3238 40.3649 16.2005 40.1798 16.118 39.9758C16.0354 39.7717 15.9954 39.553 16.0004 39.333C16.0004 38.8619 16.1604 38.4663 16.4804 38.1463C16.6351 37.9898 16.8201 37.8664 17.0242 37.7839C17.2282 37.7014 17.447 37.6614 17.667 37.6664H35.9994C36.4716 37.6664 36.8677 37.8264 37.1877 38.1463C37.344 38.3012 37.467 38.4863 37.5493 38.6903C37.6315 38.8944 37.6712 39.113 37.666 39.333C37.666 39.804 37.5066 40.1996 37.1877 40.5196C37.0328 40.6763 36.8475 40.7998 36.6432 40.8823C36.4388 40.9649 36.2198 41.0048 35.9994 40.9995H17.667Z"
            fill="#009F7F"
          />
          <path
            d="M39.9988 31L44.8319 35.8331C44.9837 35.9861 45.1026 36.1685 45.1814 36.3691C45.2603 36.5697 45.2973 36.7843 45.2902 36.9997C45.2973 37.2151 45.2603 37.4297 45.1814 37.6303C45.1026 37.8309 44.9837 38.0133 44.8319 38.1663C44.6789 38.3181 44.4965 38.4371 44.2959 38.5159C44.0953 38.5947 43.8807 38.6317 43.6653 38.6247C43.4499 38.6317 43.2353 38.5947 43.0347 38.5159C42.8341 38.4371 42.6517 38.3181 42.4987 38.1663L36.499 32.1666C36.3405 32.0166 36.2144 31.8357 36.1284 31.635C36.0424 31.4344 35.9984 31.2183 35.999 31C35.999 30.5556 36.1657 30.1667 36.499 29.8334L42.4987 23.8337C42.6517 23.6819 42.8341 23.563 43.0347 23.4842C43.2353 23.4054 43.4499 23.3684 43.6653 23.3754C44.1375 23.3754 44.5264 23.5282 44.8319 23.8337C44.9837 23.9867 45.1026 24.1691 45.1814 24.3697C45.2603 24.5703 45.2973 24.7849 45.2902 25.0003C45.2973 25.2157 45.2603 25.4303 45.1814 25.6309C45.1026 25.8315 44.9837 26.0139 44.8319 26.1669L39.9988 31Z"
            fill="#009F7F"
          />
          <path
            d="M17.667 24.3337C17.4471 24.3389 17.2284 24.2991 17.0244 24.2169C16.8204 24.1346 16.6353 24.0116 16.4804 23.8554C16.3237 23.7005 16.2002 23.5152 16.1177 23.3108C16.0351 23.1065 15.9952 22.8874 16.0005 22.6671C16.0005 22.1949 16.1604 21.7988 16.4804 21.4788C16.6353 21.3225 16.8204 21.1995 17.0244 21.1173C17.2284 21.035 17.4471 20.9953 17.667 21.0005H35.9995C36.2197 20.9951 36.4387 21.0347 36.643 21.1169C36.8473 21.1992 37.0327 21.3223 37.1878 21.4788C37.3442 21.6338 37.4674 21.8192 37.5496 22.0235C37.6319 22.2279 37.6715 22.4469 37.6661 22.6671C37.6715 22.8873 37.6319 23.1063 37.5496 23.3106C37.4674 23.5149 37.3442 23.7003 37.1878 23.8554C37.0327 24.0118 36.8473 24.135 36.643 24.2172C36.4387 24.2995 36.2197 24.3391 35.9995 24.3337H17.667Z"
            fill="#009F7F"
          />
          <path
            d="M17.667 32.6666C17.447 32.6716 17.2282 32.6316 17.0242 32.549C16.8201 32.4665 16.6351 32.3432 16.4804 32.1866C16.3238 32.0319 16.2005 31.8469 16.118 31.6428C16.0354 31.4388 15.9954 31.22 16.0004 31C16.0004 30.5278 16.1604 30.1317 16.4804 29.8117C16.6352 29.6554 16.8203 29.5324 17.0244 29.4502C17.2284 29.3679 17.4471 29.3282 17.667 29.3334H30.9997C31.2199 29.328 31.4389 29.3676 31.6432 29.4498C31.8476 29.5321 32.0329 29.6552 32.188 29.8117C32.3444 29.9667 32.4676 30.1521 32.5498 30.3565C32.6321 30.5608 32.6717 30.7798 32.6663 31C32.6663 31.4711 32.5068 31.8666 32.188 32.1866C32.0331 32.3434 31.8478 32.4668 31.6434 32.5494C31.4391 32.6319 31.22 32.6718 30.9997 32.6666H17.667Z"
            fill="#009F7F"
          />
        </svg>
      </span>

      <div className="store-products">
        <p className="mb-0 pagination-heading">
          {selectedStore?.name}
          {selectedStore?.name && nearbyStores?.length > 0 && (
            <HiChevronDoubleRight size={20} />
          )}
          {!loader &&
            totalRecords > 0 &&
            `${nearbyStores.length} Stores shown out of ${totalRecords}`}
        </p>
        <div className="d-flex gap-2 flex-wrap">
          <div
            className="relative inline-block text-left font-inter"
            ref={dropdownRef}
          >
            {/* Dropdown Toggle Button */}
            <button
              type="button"
              className={`sorting-dropdown ${nearbyStores.length == 0 ? "disabled-filter" : ""}`}
              onClick={() => setDropdownOpen(!dropdownOpen)}
              aria-haspopup="true"
              aria-expanded={dropdownOpen ? "true" : "false"}
              disabled={nearbyStores?.length === 0}
            >
              <span>{getSelectedLabel()}</span>
              <BsCaretDownFill />
            </button>
            {/* Dropdown Menu */}
            {dropdownOpen && (
              <div
                className="sorting-dropdown-menu"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="menu-button"
              >
                <div role="none" className="sorting-dropdown-options">
                  {options.map((option) => (
                    <label
                      className={`sorting-dropdown-options-label ${
                        selectedSortOption?.value === option.value
                          ? "active"
                          : ""
                      }`}
                      key={option.value}
                      htmlFor={`radio-${option.value}`}
                      role="menuitem"
                    >
                      <input
                        className="sorting-dropdown-options-input"
                        type="radio"
                        id={`radio-${option.value}`}
                        name="productSort"
                        value={option.value}
                        checked={selectedSortOption?.value === option.value}
                        onChange={(e) => handleRadioChange(e, option.label)}
                      />
                      {option.label}
                    </label>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="relative inline-block text-left font-inter search-store-wrapper">
            <input
              type="text"
              placeholder="Search By Store Name"
              className="searchStore"
              value={searchText}
              onChange={handleSearch}
              onKeyDown={handleKeyDown}
            />
            <BsSearch
              className="search-icon"
              color="black"
              onClick={handleSearchClick}
            />
          </div>
        </div>
      </div>
      {loader ? (
        <div colSpan="14">
          <Loader />
        </div>
      ) : nearbyStores?.length > 0 ? (
        <div className="flex-product-list">
          {nearbyStores.map((el) => (
            <div className="flex-cards--wrap" key={el?.storeID}>
              <div className="card-box">
                <div
                  className="box-inner"
                  onClick={() => {
                    handleStoreLatLng(el?.latitude, el?.longitude, el?.storeID);
                    scrollToSection(scrollToMapSectionRef);
                    setRecenterCurLoc(false);
                  }}
                >
                  <div
                    className={
                      selectedStoreID === el?.storeID
                        ? "card-container-right active-store-card"
                        : "card-container-right"
                    }
                  >
                    <div className="d-f j-sb a-c mb-10xx mb-5pxx mb-title-head">
                      <h4>{el?.businessName}</h4>

                      <span
                        className="navigate-icon--new"
                        title="Navigate"
                        onClick={() =>
                          openGoogleDirections(el?.latitude, el?.longitude)
                        }
                      >
                        <RiDirectionLine size={25} />
                      </span>
                    </div>

                    <h4 className="product-address-title mb-10">
                      {el?.address}
                    </h4>
                    <div className="d-f j-sb mt-1">
                      <div className="flex-content-01 horizontal-scrollbar">
                        {el?.deliveryTypes?.map((el) => (
                          <OverlayTrigger
                            key={el?.deliveryTypeID}
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-${el?.deliveryTypeID}`}>
                                Delivery Option
                              </Tooltip>
                            }
                          >
                            <p className="scroller-data">
                              {(el?.shortCode === "HD" && (
                                <CImage src="/images/bike.svg" height={20} />
                              )) ||
                                (el?.shortCode === "SP" && (
                                  <CImage src="/images/bag.svg" />
                                )) ||
                                (el?.shortCode === "COD" && (
                                  <CImage
                                    src="/images/rupee-sign.svg"
                                    height={12}
                                    width={9}
                                  />
                                )) ||
                                (el?.shortCode === "DN" && (
                                  <CImage
                                    src="/images/rupee-sign.svg"
                                    height={12}
                                    width={9}
                                  />
                                )) ||
                                (el?.shortCode === "HV" && <MdStore />) ||
                                (el?.shortCode === "SV" && <MdStore />)}

                              {el.name}
                            </p>
                          </OverlayTrigger>
                        ))}
                        {el?.paymentOptions?.map((el) => (
                          <OverlayTrigger
                            key={el?.paymentOptionID}
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-${el?.paymentOptionID}`}>
                                Payment Option
                              </Tooltip>
                            }
                          >
                            <p className="scroller-data">{el.type}</p>
                          </OverlayTrigger>
                        ))}
                      </div>
                    </div>

                    <div className="product-type-wrapper mt-2">
                      <div className="flex-content-01 storeTypeName">
                        <p className="text-color-grey br-color-grey fw-600">
                          {el?.storeTypeName}
                        </p>
                      </div>

                      <marquee className="marq" direction="left" width="90%">
                        {el?.note}
                      </marquee>
                    </div>

                    {/* {el?.webUrl && ( */}
                    <div className="available-status-badge justify-content-end">
                      <div
                        className={
                          selectedStoreID === el?.storeID
                            ? "image-box-ezy active-store-card"
                            : "image-box-ezy"
                        }
                      >
                        <h3 className="product-title">
                          <span className="d-f a-c j-c gap-1 text-lower">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="18"
                              viewBox="0 0 14 17"
                              fill="none"
                              className="zoom-io"
                            >
                              <path
                                d="M13.6398 8.5459H9.63984C9.57109 8.5459 9.51484 8.60215 9.51484 8.6709V9.4209C9.51484 9.48965 9.57109 9.5459 9.63984 9.5459H13.6398C13.7086 9.5459 13.7648 9.48965 13.7648 9.4209V8.6709C13.7648 8.60215 13.7086 8.5459 13.6398 8.5459ZM11.5461 10.6709H9.63984C9.57109 10.6709 9.51484 10.7271 9.51484 10.7959V11.5459C9.51484 11.6146 9.57109 11.6709 9.63984 11.6709H11.5461C11.6148 11.6709 11.6711 11.6146 11.6711 11.5459V10.7959C11.6711 10.7271 11.6148 10.6709 11.5461 10.6709ZM6.33203 7.14746H5.65547C5.55859 7.14746 5.48047 7.22559 5.48047 7.32246V11.1975C5.48047 11.2537 5.50703 11.3053 5.55234 11.3381L7.87891 13.035C7.95703 13.0912 8.06641 13.0756 8.12266 12.9975L8.52422 12.449V12.4475C8.58047 12.3693 8.56328 12.26 8.48516 12.2037L6.50547 10.7725V7.32246C6.50703 7.22559 6.42734 7.14746 6.33203 7.14746Z"
                                fill="#E35F00"
                              />
                              <path
                                d="M11.45 12.638H10.5469C10.4594 12.638 10.3766 12.6833 10.3297 12.7583C10.1313 13.0724 9.90001 13.363 9.63439 13.6286C9.17657 14.0864 8.64376 14.4458 8.05157 14.6958C7.43751 14.9552 6.78595 15.0864 6.11407 15.0864C5.44064 15.0864 4.78907 14.9552 4.17657 14.6958C3.58439 14.4458 3.05157 14.0864 2.59376 13.6286C2.13595 13.1708 1.77657 12.638 1.52657 12.0458C1.2672 11.4333 1.13595 10.7817 1.13595 10.1083C1.13595 9.43485 1.2672 8.78485 1.52657 8.17079C1.77657 7.5786 2.13595 7.04579 2.59376 6.58798C3.05157 6.13016 3.58439 5.77079 4.17657 5.52079C4.78907 5.26141 5.4422 5.13016 6.11407 5.13016C6.78751 5.13016 7.43907 5.26141 8.05157 5.52079C8.64376 5.77079 9.17657 6.13016 9.63439 6.58798C9.90001 6.8536 10.1313 7.14423 10.3297 7.45829C10.3766 7.53329 10.4594 7.5786 10.5469 7.5786H11.45C11.5578 7.5786 11.6266 7.4661 11.5781 7.37079C10.5594 5.34423 8.49376 4.02704 6.18751 4.00048C2.81095 3.95829 0.00626067 6.72235 1.06747e-05 10.0958C-0.00623933 13.4755 2.73282 16.2177 6.11251 16.2177C8.44845 16.2177 10.5484 14.8958 11.5781 12.8458C11.6266 12.7505 11.5563 12.638 11.45 12.638Z"
                                fill="black"
                              />
                              <path
                                d="M6.5 3L7.79904 0.75H5.20096L6.5 3Z"
                                fill="black"
                              />
                            </svg>
                            <span className="delivery-time">
                              {el?.estimatedDuration}
                            </span>
                          </span>
                        </h3>
                        <h3 className="product-title">
                          <CImage
                            src="/images/location.png"
                            style={{ height: "20px", width: "20px" }}
                          />
                          {el?.estimatedDistanceKm?.toFixed(2)}km
                        </h3>
                      </div>

                      <button
                        className="visit-store-btn"
                        type="button"
                        onClick={() => navigateOnStore(el?.vendorID)}
                      >
                        Visit Store <BsBoxArrowUpRight />
                      </button>
                    </div>
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-store-found">
          <img
            src="./images/no-store-found-01.svg"
            alt="no-store-found"
            className="ezy-full-img mt-5"
            width={450}
          />
        </div>
      )}

      {nearbyStores?.length > 0 && nearbyStores.length < totalRecords && (
        <div className="load-more-btn-div">
          <CButton className="load-more-btn" onClick={handleLoadMore}>
            Load More <BsArrowClockwise color="white" />
          </CButton>
        </div>
      )}
    </div>
  );
};

export default StoreListing;
